<div #chart data-testid="spend-bars" class="spend-bars" role="img" aria-label="Daily XatBot spend, last 30 days"></div>
